export default __webpack_public_path__ + "static/media/analyst3.bc19b749.png";